export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}


// 微信网页授权url
export function GetWechatAuthUrl(redirect) {
  const uuidStr = uuid();
  // // 记录cookie
  // Cookies.set('lshoot-qupaipai-hkm-account-machineCode', state, { expires: 1 })
  window.localStorage.machineCode = uuidStr //机械码，确保当前授权用户为操作用户本身

  // if(redirect.indexOf('?')>-1)
  //   redirect = `${redirect}&machineCode=${uuidStr}`
  // else
  //   redirect = `${redirect}?machineCode=${uuidStr}`

  //return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${Appid}&redirect_uri=http%3A%2F%2Ftest.hkm.lshoot.com%2Flogin&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
  return `${window.PcWebSite}/Api/Wechat/Invoking?redirect=${encodeURIComponent(redirect)}&state=${uuidStr}`
}


// WEBPACK FOOTER //
// ./src/utils/common.js